export const environment = {
  production: false,
  version: '0.0.0',
  apiConfig: {
    apiProvider: '/api',
    apiVersion: '/v1',
    // baseApiUrl: 'https://localhost:7142',
    baseApiUrl: 'https://dev.iearms.org:8443',
    signalRBaseApiUrl: '/examHub',
    institutionPortalHubUrl: '/institution-portal-notification-hub',
    wsUrl: 'https://dev.iearms.org:8443',
    serverUrl: '',
    accreditationDownstreamUrl: '/accreditation/api',
    tvetAccreditationRequestEndpointSubUrl: 'accreditation/tvet',
    generalEducationAccreditationRequestEdnpointSubUrl:
      'accreditation/general-edu',
    commonAccreditationServicesEndpointSubUrl: 'accreditation/common-utils',
    assessmentBaseUrl: '/assessment/api',
  },
  socketUrl: 'ws://localhost:30080/notifications',
  wsUrl: 'wss://dev.iearms.org:8443',
  msalConfig: {
    auth: {
      clientId: '7b545dc9-189c-463f-bc9a-1d9f56ea2da3',
      tenantId: '2ec45f6d-708d-4b7e-a1e9-18ed219c39ec',
      authority:
        'https://gammtechnology.b2clogin.com/GAMMTechnology.onmicrosoft.com/B2C_1_signIn',
    },
    redirectUri: 'https://dev.iearms.org/dashboard',
    postLogoutRedirectUri: 'https://dev.iearms.org',
    navigateToLoginRequestUrl: false,
    authorityDomain: 'gammtechnology.b2clogin.com',
  },
  microsoftIndividualRegisterAuthority: 'B2C_1_Individual_Signup',
  microsoftInstitutionRegisterAuthority: 'B2C_1_Institution_Signup',
  microsoftPasswordResetAuthority: 'B2C_1_password_reset',
  languageConfig: {
    defaultLanguage: {
      name: 'English',
      code: 'en',
    },
    supportedLanguages: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Amharic',
        code: 'am',
      },
      {
        name: 'Oromo',
        code: 'or',
      },
    ],
  },
  keycloakConfig: {
    url: 'https://keycloak.iearms.org:8843/auth/',
    realm: 'iearms-dev',
    clientId: 'iearms-web',
    redirectUri: 'https://dev.iearms.org/dashboard',
    postLogoutRedirectUri: 'https://dev.iearms.org',
    institutionRegistrationFlow:
      'https://keycloak.iearms.org:8843/auth/realms/iearms-dev/protocol/openid-connect/registrations?client_id=iearms-web&response_type=code&scope=openid&redirect_uri=http://localhost:4200&kc_idp_hint=institution-registration',
    individualRegistrationFlow:
      'https://keycloak.iearms.org:8843/auth/realms/iearms-dev/protocol/openid-connect/registrations?client_id=iearms-web&response_type=code&scope=openid&redirect_uri=http://localhost:4200&kc_idp_hint=user-registration',
  },
  telebirrConfig: {
    merchantAppId: '1335252621849605',
  },
  paymentCallbackNotificationHubUrl: 'payment-notification-hub',
};

environment.apiConfig.serverUrl = `${environment.apiConfig.baseApiUrl}${environment.apiConfig.apiProvider}`;
